// extracted by mini-css-extract-plugin
export var category = "categoryPill-module--category--42fe8";
export var categoryPill = "categoryPill-module--category-pill--a4949";
export var greyGold = "categoryPill-module--grey-gold--3d796";
export var greyRed = "categoryPill-module--grey-red--d4cae";